import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function FeaturedTestimonialsSection() {
  const testimonials = [
  {
    id: 'testimonial_joao',
    quote: "We've worked with SDSA for 5 years now, and they've never let us down. The sunflower oil quality is consistently excellent. Every shipment meets our high standards. Their team is always responsive and helpful.",
    name: "João Silva",
    position: "Import Manager",
    company: "Brasil Foods Ltd",
    country: "Brazil",
    countryFlag: "🇧🇷",
    product: "Sunflower Oil",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb00d656-1763291827615.png",
    alt: "Professional headshot of João Silva, Import Manager",
    rating: 5
  },
  {
    id: 'testimonial_ahmed',
    quote: "Switching to SDSA\'s wood pellets boosted our energy efficiency by 15%. Their technical team helped us optimize everything. The quality stays consistent batch after batch. Great partnership all around.",
    name: "Ahmed Hassan",
    position: "Procurement Director",
    company: "Maroc Energy Co.",
    country: "Morocco",
    countryFlag: "🇲🇦",
    product: "Wood Pellets",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15ebdb31b-1763300068284.png",
    alt: "Professional headshot of Ahmed Hassan, Procurement Director",
    rating: 5
  }];


  return (
    <section className="py-24 bg-background">
      <div className="max-w-container mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary mb-4">
            Client Success Stories
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6">
            Trusted by Industry Leaders Worldwide
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our partners around the world say about working with SDSA.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {testimonials?.map((testimonial, index) =>
          <div
            key={testimonial?.id}
            className="reveal"
            style={{ transitionDelay: `${index * 150}ms` }}>
            
              <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-organic-lg p-8 h-full hover-lift">
                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial?.rating)]?.map((_, i) =>
                <Icon key={`star_${i}`} name="StarIcon" size={20} className="text-yellow-400 fill-current" />
                )}
                </div>

                {/* Quote */}
                <blockquote className="text-lg text-foreground leading-relaxed mb-6 italic font-serif">
                  "{testimonial?.quote}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0">
                    <AppImage
                    src={testimonial?.image}
                    alt={testimonial?.alt}
                    className="w-16 h-16 rounded-full object-cover" />
                  
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="font-bold text-foreground">{testimonial?.name}</h4>
                      <span className="text-2xl" title={testimonial?.country}>{testimonial?.countryFlag}</span>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      {testimonial?.position}, {testimonial?.company}
                    </p>
                    <p className="text-xs text-primary font-semibold mt-1">
                      Product: {testimonial?.product}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA to Testimonials Page */}
        <div className="text-center reveal">
          <Link
            href="/testimonials"
            className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-4 transition-all">
            
            Read More Success Stories
            <Icon name="ArrowRightIcon" size={20} className="arrow-shift" />
          </Link>
        </div>
      </div>
    </section>
  );

}